import React from "react";
import { CloudOff } from "lucide-react";
import { MlsFeedStatus } from "../../hooks/useMlsFeedStatus";

interface MlsFeedStatusBannerProps {
    status: MlsFeedStatus | null;
}

// MB-1611: shown on the Listings page while the MLS feed is down (detected, or
// held offline by an admin). Says what is happening and that nothing needs doing;
// listings that are waiting show their own "Waiting for MLS …" status on the card.
const MlsFeedStatusBanner: React.FC<MlsFeedStatusBannerProps> = ({ status }) => {
    if (!status || status.online) return null;
    const lane =
        status.data && !status.photos
            ? "MLS photo downloads are currently unavailable."
            : "The MLS data feed is currently unavailable.";
    return (
        <div
            role="status"
            data-testid="mls-feed-status-banner"
            className="mb-4 flex w-full items-start gap-3 rounded-lg border border-[#f0c755] bg-[#fff176]/30 px-4 py-3 text-sm text-primary shadow-sm"
        >
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#f0c755]/40">
                <CloudOff className="h-[18px] w-[18px] text-primary" />
            </span>
            <div className="flex flex-col gap-0.5">
                <span className="font-semibold">{lane}</span>
                <span>{status.message}</span>
                <span className="text-primary/80">
                    Listings you add will finish on their own once the feed is back. Your
                    existing listings, campaigns and scheduled posts are not affected.
                </span>
            </div>
        </div>
    );
};

export default MlsFeedStatusBanner;
